import axios from 'axios';

/**
 * Servicio para gestionar actividades y tareas del Gantt en eventos
 * Usa baseURL /api/eventos/ para acceder a los endpoints de la app eventos
 */

const API_URL = process.env.REACT_APP_API_URL ?
  process.env.REACT_APP_API_URL.replace('/api/content', '/api/eventos') :
  'http://localhost:8000/api/eventos';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para CSRF token
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Añadir CSRF token a peticiones POST/PUT/DELETE
api.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = getCookie('csrftoken');
  }
  return config;
});

const eventosGanttService = {
  // ============ EVENTOS ============

  eventos: {
    list: (params = {}) =>
      api.get(`eventos/`, { params }),

    retrieve: (id) =>
      api.get(`eventos/${id}/`),

    create: (data) =>
      api.post(`eventos/`, data),

    update: (id, data) =>
      api.patch(`eventos/${id}/`, data),

    delete: (id) =>
      api.delete(`eventos/${id}/`)
  },

  // ============ ACTIVIDADES ============

  actividades: {
    list: (eventoId, params = {}) =>
      api.get(`actividades/`, { params: { evento: eventoId, ...params } }),

    retrieve: (id) =>
      api.get(`actividades/${id}/`),

    create: (data) =>
      api.post(`actividades/`, data),

    update: (id, data) =>
      api.patch(`actividades/${id}/`, data),

    delete: (id) =>
      api.delete(`actividades/${id}/`),

    reordenar: (id, orden) =>
      api.post(`actividades/${id}/reordenar/`, { orden })
  },

  // ============ TAREAS ============

  tareas: {
    list: (params = {}) =>
      api.get(`tareas/`, { params }),

    listByActividad: (actividadId, params = {}) =>
      api.get(`tareas/`, { params: { actividad: actividadId, ...params } }),

    listByEvento: (eventoId, params = {}) =>
      api.get(`tareas/`, { params: { evento: eventoId, ...params } }),

    listByProyecto: (proyectoId, params = {}) =>
      api.get(`tareas/`, { params: { evento__proyecto: proyectoId, ...params } }),

    retrieve: (id) =>
      api.get(`tareas/${id}/`),

    create: (data) =>
      api.post(`tareas/`, data),

    update: (id, data) =>
      api.patch(`tareas/${id}/`, data),

    delete: (id) =>
      api.delete(`tareas/${id}/`),

    crearTimelog: (id, timelogData) =>
      api.post(`tareas/${id}/crear_timelog/`, timelogData),

    recalcularHoras: (id) =>
      api.post(`tareas/${id}/recalcular_horas/`),

    validarStockRecursos: (params = {}) =>
      api.get(`tareas/validar_stock_recursos/`, { params })
  },

  // ============ TIMELOGS ============

  timelogs: {
    list: (params = {}) =>
      api.get(`timelogs/`, { params }),

    listByTarea: (tareaId, params = {}) =>
      api.get(`timelogs/`, { params: { tarea: tareaId, ...params } }),

    retrieve: (id) =>
      api.get(`timelogs/${id}/`),

    create: (data) =>
      api.post(`timelogs/`, data),

    update: (id, data) =>
      api.patch(`timelogs/${id}/`, data),

    delete: (id) =>
      api.delete(`timelogs/${id}/`)
  }
};

export default eventosGanttService;
